<template>
	<div class="payment-container">
		<v-layout row wrap class="header-actions">
			<v-flex xs12 sm6>
				<h1 class="payment-title">BOOKING RECEIPT</h1>
			</v-flex>
			<v-flex xs12 sm6 class="text-sm-right">
				<v-btn v-if="$bookingPaidStatus === false"
							 depressed
							 color="#74a533"
							 class="action-btn"
							 @click="openPayment()">
					<v-icon left>mdi-credit-card</v-icon>
					Add Payment
				</v-btn>
				<v-btn depressed
							 color="#74a533"
							 class="action-btn"
							 @click="printReceipt">
					<v-icon left>mdi-printer</v-icon>
					Print Invoice
				</v-btn>
				<v-btn depressed
							 color="#74a533"
							 class="action-btn"
							 @click="openJavaApplication()">
					<v-icon left>mdi-printer</v-icon>
					Print Receipt
				</v-btn>
			</v-flex>
		</v-layout>

		<v-card flat class="payment-card fade-enter-active">
			<v-layout row wrap>
				<!-- Booking Information Section -->
				<v-flex xs12 md6 class="pr-md-3">
					<v-card flat class="info-card">
						<h2 class="section-title">
							<v-icon color="#74a533">mdi-information</v-icon>
							Booking Information
						</h2>
						<v-simple-table class="compact-table">
							<tbody>
								<tr>
									<td><strong>Booking ID:</strong></td>
									<td>
  <a :href="'https://bookings.olpejetaconservancy.org/booking/' + singleBooking.booking_public_id" target="_blank">
    {{ singleBooking.booking_ref_code }}
  </a>
</td></tr>
								<tr>
									<td><strong>Guest:</strong></td>
									<td>{{ singleBooking.booking_done_by }}</td>
								</tr>
								<tr>
									<td><strong>Phone:</strong></td>
									<td>{{ singleBooking.booking_details.phone_number }}</td>
								</tr>
								<tr>
									<td><strong>Email:</strong></td>
									<td>{{ singleBooking.booking_details.email_address }}</td>
								</tr>
								<tr>
									<td><strong>Destination:</strong></td>
									<td>{{ singleBooking.destination }}</td>
								</tr>
								<tr>
									<td><strong>Status:</strong></td>
									<td>{{ singleBooking.booking_payment_status }}</td>
								</tr>
								<tr>
									<td><strong>Dates:</strong></td>
									<td>{{ formated_date(singleBooking.booking_check_in_date) }} - {{ formated_date(singleBooking.booking_check_out_date) }}</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-card>
				</v-flex>

				<!-- Quick Actions Section -->
				<v-flex xs12 md6 class="pl-md-3">
					<v-card flat class="actions-card">
						<h2 class="section-title">
							<v-icon color="#74a533">mdi-tools</v-icon>
							Quick Actions
						</h2>
						<v-layout row wrap>
							<v-flex xs12 sm6 class="pa-1">
								<v-btn v-if="$bookingPaidStatus === true && singleBooking.booking_check_in_status === 'Not Checked In'"
											 depressed
											 color="#74a533"
											 block
											 class="action-btn"
											 @click="openCheckIn()">
									<v-icon left>mdi-check</v-icon>
									Check In
								</v-btn>
								<v-btn depressed
											 color="#74a533"
											 block
											 class="action-btn"
											 @click="populateEmailValue"
											 v-on="dialog ? {} : { click: () => dialog = true }">
									<v-icon left>mdi-email</v-icon>
									Send Mail
								</v-btn>
							</v-flex>
							<v-flex xs12 sm6 class="pa-1">
								<v-btn v-if="$bookingPaidStatus === false"
											 depressed
											 color="#74a533"
											 block
											 class="action-btn"
											 @click="deferPayment()">
									<v-icon left>mdi-clock</v-icon>
									Defer Payment
								</v-btn>
								<v-btn depressed
											 color="#d32f2f"
											 block
											 class="action-btn"
											 :loading="this.$store.state.LoadingStore.loading"
											 @click="markAsFOC()">
									<v-icon left>mdi-gift</v-icon>
									Mark As FOC
								</v-btn>
							</v-flex>
							<v-flex xs12 class="pa-1">
								<v-btn v-if="$bookingPaidStatus === false && singleBooking.booking_type !== 'Partner Booking' && singleBooking.status !== 'Cancelled'"
											 depressed
											 color="#74a533"
											 block
											 class="action-btn"
											 @click="sendReminder()">
									<v-icon left>mdi-email</v-icon>
									Send Payment Reminder
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card>
				</v-flex>
			</v-layout>

			<!-- Combined Fees Section -->
			<v-card flat class="section-card" v-if="hasGuests || hasVehicles">
				<h2 class="section-title">
					<v-icon color="#74a533">mdi-receipt</v-icon>
					Fees Summary
				</h2>

				<!-- Conservancy Fees Subsection -->
				<div v-if="hasGuests" class="fee-subsection">
					<h3 class="subsection-title">
						<v-icon color="#74a533">mdi-ticket-account</v-icon>
						Conservancy Fees
					</h3>
					<v-simple-table class="compact-table">
						<thead>
							<tr>
								<th>Residency</th>
								<th>Guests</th>
								<th>Amount</th>
								<th>Discount%</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(guest, key) in singleBooking.guests" v-if="guest.payment_guests > 0" :key="key">
								<td>{{guest.payment_person}}</td>
								<td>{{guest.payment_guests}}</td>
								<td>{{guest.payment_person_currency}} {{$roundOff(guest.payment_guests * guest.payment_person_amount * guest.no_of_nights * ((100 - guest.payment_person_discount) / 100))}}</td>
								<td>{{guest.payment_person_discount}}%</td>
							</tr>
							<tr class="subsection-total">
								<td colspan="2"><strong>Total Conservancy Fees:</strong></td>
								<td colspan="2" class="text-right">
									<strong>{{singleBooking.currency}} {{$roundOff(calculateConservancyTotal())}}</strong>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</div>

				<!-- Vehicle Fees Subsection -->
				<div v-if="hasVehicles" class="fee-subsection">
					<h3 class="subsection-title">
						<v-icon color="#74a533">mdi-car</v-icon>
						Vehicle Fees
					</h3>
					<v-simple-table class="compact-table">
						<thead>
							<tr>
								<th>Vehicle Type</th>
								<th>No. of Vehicles</th>
								<th>Amount</th>
								<th>Discount %</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(vehicle, key) in singleBooking.vehicles" v-if="vehicle.vehicles > 0" :key="key">
								<td>{{vehicle.vehicle_charge_category}}</td>
								<td>{{vehicle.vehicles}}</td>
								<td>{{singleBooking.currency}} {{$roundOff(convert1(vehicle.vehicle_charge_cost_currency, vehicle.vehicles * vehicle.vehicle_charge_category_cost * vehicle.vehicle_no_of_nights * ((100 - vehicle.discount) / 100)).amount)}}</td>
								<td>{{vehicle.discount}}%</td>
							</tr>
							<tr class="subsection-total">
								<td colspan="2"><strong>Total Vehicle Fees:</strong></td>
								<td colspan="2" class="text-right">
									<strong>{{singleBooking.currency}} {{$roundOff(calculateVehicleTotal())}}</strong>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</div>
			</v-card>

			<!-- Accommodation Section -->
			<v-card flat class="section-card" v-if="singleBooking.facility_bookings.length > 0">
				<h2 class="section-title">
					<v-icon color="#74a533">mdi-home</v-icon>
					Accommodation
				</h2>
				<v-simple-table class="compact-table">
					<thead>
						<tr>
							<th>Name</th>
							<th>Guests</th>
							<th>Duration</th>
							<th>Amount</th>
							<th>Discount %</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(facility, key) in singleBooking.facility_bookings" :key="key">
							<td>{{facility.facility_name}}</td>
							<td>{{facility.facility_booking_guests}}</td>
							<td>{{formated_date(facility.facility_booking_check_in_date)}} - {{formated_date(facility.facility_booking_check_out_date)}}</td>
							<td>{{facility.facility_booking_currency}} {{$roundOff(facility.facility_booking_total_cost)}}</td>
							<td>{{facility.facility_booking_discount_percentage}}</td>
						</tr>
					</tbody>
				</v-simple-table>
			</v-card>

			<!-- Activities Section -->
			<v-card flat class="section-card" v-if="singleBooking.inventory_bookings.length > 0">
				<h2 class="section-title">
					<v-icon color="#74a533">mdi-run</v-icon>
					Activities
				</h2>
				<v-simple-table class="compact-table">
					<thead>
						<tr>
							<th>Name</th>
							<th>Guests</th>
							<th>Date</th>
							<th>Amount</th>
							<th>Discount %</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(activity, key) in singleBooking.inventory_bookings" :key="key">
							<td>{{activity.inventory_name}}</td>
							<td>{{activity.inventory_booking_guests}}</td>
							<td>{{formated_date(activity.inventory_booking_date)}}</td>
							<td>{{activity.inventory_booking_currency}} {{$roundOff(activity.inventory_booking_total_cost)}}</td>
							<td>{{activity.inventory_booking_discount_percentage}}</td>
						</tr>
					</tbody>
				</v-simple-table>
			</v-card>

			<!-- Total Summary Section -->
			<v-card flat class="section-card total-section">
				<h2 class="section-title">
					<v-icon color="#74a533">mdi-cash</v-icon>
					Payment Summary
				</h2>
				<v-simple-table class="compact-table">
					<tbody>
						<tr v-if="singleBooking.catering_levy !== null">
							<td><strong>Catering Levy:</strong></td>
							<td class="text-right">{{$roundOff(singleBooking.catering_levy.tax)}}</td>
						</tr>
						<tr>
							<td><strong>Sub Total:</strong></td>
							<td class="text-right">{{$roundOff(singleBooking.vat.after_tax)}}</td>
						</tr>
						<tr>
							<td><strong>VAT:</strong></td>
							<td class="text-right">{{$roundOff(singleBooking.vat.tax)}}</td>
						</tr>
						<tr class="total-row">
							<td><strong>TOTAL:</strong></td>
							<td class="text-right"><strong>{{singleBooking.currency}} {{$roundOff(singleBooking.total_cost)}}</strong></td>
						</tr>
					</tbody>
				</v-simple-table>
			</v-card>

			<v-dialog v-model="dialog" persistent max-width="600px">
				<v-card class="email-dialog">
					<v-card-title class="dialog-title">
						<span>Add Emails</span>
						<v-spacer></v-spacer>
						<v-btn icon @click="dialog = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-flex xs12>
								<v-text-field label="Email*"
															required
															:value="singleBooking.booking_details.email_address"
															v-model="emails.email"
															placeholder="john@apple.com, obts@olpejetaconservancy.org"
															outlined
															dense
															prepend-inner-icon="mdi-email"></v-text-field>
								<p class="text-note">* Separate the emails with a comma</p>
							</v-flex>
						</v-container>
					</v-card-text>
					<v-card-actions class="dialog-actions">
						<v-btn color="#d32f2f" depressed @click="dialog = false" class="action-btn">
							<v-icon left>mdi-close</v-icon>
							Close
						</v-btn>
						<v-btn color="#74a533" depressed @click="sendMail()" class="action-btn">
							<v-icon left>mdi-send</v-icon>
							Send
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card>
	</div>
</template>

<script>
	import GatePayment from './GatePayment'

	export default {
		components: { GatePayment },
		data() {
			return {
				dialog: false,
				canceling: false,
				emails: {
					email: ''
				}
			}
		},
		computed: {
			hasGuests() {
				return this.singleBooking.guests && this.singleBooking.guests.some(g => g.payment_guests > 0)
			},
			hasVehicles() {
				return this.singleBooking.vehicles && this.singleBooking.vehicles.some(v => v.vehicles > 0)
			}
		},
		methods: {
			calculateConservancyTotal() {
				if (!this.singleBooking.guests) return 0;
				return this.singleBooking.guests.reduce((total, guest) => {
					if (guest.payment_guests > 0) {
						return total + (guest.payment_guests * guest.payment_person_amount * guest.no_of_nights * ((100 - guest.payment_person_discount) / 100));
					}
					return total;
				}, 0);
			},
			calculateVehicleTotal() {
				if (!this.singleBooking.vehicles) return 0;
				return this.singleBooking.vehicles.reduce((total, vehicle) => {
					if (vehicle.vehicles > 0) {
						const convertedAmount = this.convert1(
							vehicle.vehicle_charge_cost_currency,
							vehicle.vehicles * vehicle.vehicle_charge_category_cost * vehicle.vehicle_no_of_nights * ((100 - vehicle.discount) / 100)
						).amount;
						return total + convertedAmount;
					}
					return total;
				}, 0);
			},
			sendReminder: function () {
				this.$store.dispatch('send_email_payment_reminder', this.$route.params.booking_id)
			},
			markAsFOC() {
				this.$store.state.LoadingStore.loading = true
				var data = {
					booking_id: this.$route.params.booking_id,
					session_id: localStorage.getItem('lkjhgfdsa')
				}
				this.$store.dispatch('mark_as_foc', data)
			},
			populateEmailValue: function () {
				this.emails.email = this.singleBooking.booking_details.email_address
			},
			sendMail() {
				let emails = this.emails.email
				let emailArr = emails.split(',')
				var receipents = []
				for (var i = 0; i < emailArr.length; i++) {
					emailArr[i] = emailArr[i].replace(/^\s*/, '').replace(/\s*$/, '')
					receipents.push(emailArr[i])
				}
				let data_ = {
					booking_id: this.$route.params.booking_id,
					email: receipents,
					session_id: localStorage.getItem('lkjhgfdsa')
				}
				this.$store.dispatch('send_email', data_)
				this.disable = false
			},
			printReceipt() {
				var data = {
					booking_id: this.$route.params.booking_id,
					session_id: localStorage.getItem('lkjhgfdsa')
				}
				this.$store.dispatch('print_receipt', data)
      }, printReceipt_new() {

        var data = {
          booking_id: this.$route.params.booking_id,
          currency_id: this.currency_id,
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("print_receipt_new", data);
        this.dialog1 = false;
      },
			openCheckIn: function () {
				this.$router.push({
					name: 'Checkin',
					params: {
						booking_id: this.$route.params.booking_id
					}
				})
			},
			openPayment: function () {
				this.$router.push({
					name: 'GatePayment',
					params: {
						booking_id: this.$route.params.booking_id
					}
				})
			},
			deferPayment() {
				var data = {
					booking_id: this.$route.params.booking_id
				}
				this.$store.dispatch('defer_payment', data)
			},
			openJavaApplication() {
				this.$store.state.LoadingStore.loading = true;
				var data = {
					booking_id: this.$route.params.booking_id,
					currency_id: this.currency_id,
					session_id: localStorage.getItem("lkjhgfdsa"),
				};
				this.$store.dispatch("request_receipt", data);
			},
			formated_date(date) {
				return this.$moment(date).format('DD MMM YYYY');
			}
		},
		created() {
			this.$store.dispatch('get_booking', this.$route.params.booking_id)
		}
	}
</script>

<style scoped>
	@font-face {
		font-family: 'Earthwerk';
		src: url('PizzaDude.dk-Earthwerk.otf');
		font-weight: normal;
		font-style: normal;
	}

	.payment-container {
		background-color: #f9f9f9;
		min-height: 100vh;
		padding: 20px;
	}

	.header-actions {
		max-width: 1200px;
		margin: 0 auto 20px;
		align-items: center;
	}

	.payment-title {
		font-family: 'Earthwerk', sans-serif;
		font-size: 2rem;
		color: #4a6b22;
		margin-bottom: 10px;
	}

	.payment-card {
		max-width: 1200px;
		margin: 0 auto;
		background-color: white;
		border-radius: 10px;
		padding: 25px;
		box-shadow: 0 4px 15px rgba(0,0,0,0.05);
	}

	.info-card, .actions-card {
		background-color: #f5f9f0;
		border-radius: 10px;
		padding: 15px;
		height: 100%;
		border: 1px solid #e0e8d0;
	}

	.section-title {
		font-family: 'Earthwerk', sans-serif;
		font-size: 1.2rem;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		color: #4a6b22;
	}

		.section-title i {
			margin-right: 10px;
		}

	.section-card {
		background-color: #f5f9f0;
		border-radius: 10px;
		padding: 15px;
		margin-top: 20px;
		border: 1px solid #e0e8d0;
	}

	.fee-subsection {
		margin-bottom: 20px;
	}

	.subsection-title {
		font-family: 'Earthwerk', sans-serif;
		font-size: 1rem;
		margin: 15px 0 10px;
		display: flex;
		align-items: center;
		color: #4a6b22;
	}

	.subsection-total {
		background-color: #e8f5e9 !important;
		font-weight: bold;
	}

	.total-section {
		background-color: #e8f5e9;
	}

	.total-row {
		background-color: #c8e6c9;
	}

	.compact-table {
		width: 100%;
		background-color: transparent;
	}

		.compact-table th {
			background-color: #74a533;
			color: white;
			font-weight: 600;
		}

		.compact-table td, .compact-table th {
			padding: 8px 16px;
		}

		.compact-table tr:nth-of-type(even) {
			background-color: rgba(116, 165, 51, 0.05);
		}

	.action-btn {
		border-radius: 25px !important;
		margin: 5px 0;
		color: white !important;
		min-width: 120px;
	}

		.action-btn:hover {
			transform: scale(1.05);
			box-shadow: 0 4px 8px rgba(0,0,0,0.2);
		}

	.email-dialog {
		border-radius: 10px !important;
	}

	.dialog-title {
		background: linear-gradient(135deg, #74a533 0%, #587e27 100%);
		color: white;
		padding: 16px;
	}

	.dialog-actions {
		padding: 16px;
		display: flex;
		justify-content: flex-end;
		gap: 8px;
	}

	.text-note {
		color: #757575;
		font-size: 12px;
		margin-top: 5px;
	}

	@media (max-width: 960px) {
		.payment-title {
			font-size: 1.8rem;
		}

		.section-title {
			font-size: 1.1rem;
		}

		.pr-md-3, .pl-md-3 {
			padding-right: 0 !important;
			padding-left: 0 !important;
		}
	}

	@media (max-width: 600px) {
		.payment-title {
			font-size: 1.5rem;
			text-align: center;
		}

		.header-actions .text-sm-right {
			text-align: center !important;
		}

		.action-btn {
			width: 100%;
			margin: 5px 0;
		}
	}
</style>
